import React from "react";
import { Link } from "react-router-dom";

const ServiceCard = ({ imageSrc, title, subheadline, link }) => {
  return (
    <div className="bg-white shadow-lg rounded-3xl overflow-hidden transform transition hover:scale-105">
      <img src={imageSrc} alt={title} className="w-full h-72 object-cover" />
      <div className="p-6">
        <h3 className="text-2xl font-barlow font-bold text-main-dark mb-2">{title}</h3>
        <p className="text-text-color font-aeonik text-base mb-4">{subheadline}</p>
        <Link
          to={link}
          className="inline-block bg-main-green text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-green-700 transition"
        >
          More
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;
